import apk from "./contrall-2.31(114)-release.apk";

export default apk;
